// Added By Farhan Khan Khan on 24-Dec-2025
// Extended By System on 29-Jan-2026 - Added BOM Type column
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Spinner, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import solisPowerApi from "../../api/solisPowerApi";
import { useLocation } from "react-router-dom";
import Badge from "react-bootstrap/Badge";
import { formatDateForView, getUserDetails } from "../../utils/helper";
import { Link } from "react-router-dom";
import InfoPill from "../InfoPill";
import Main from "../layout/Main";
import { Helmet } from "react-helmet";
import { ROUTES } from "../../constants/webRouting";
import PERMISSIONS from "../../constants/permissions";

// Added by Jaseem 11-2-2026
import { DataGrid } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
//=====================================================

const BomList = () => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  const [body, setBody] = useState([]);

  //Added By Jaseem 11-02-2026
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState(rows);
  const [searchText, setSearchText] = useState("");
  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = rows.filter((row) =>
      Object.values(row).some(
        (field) =>
          field && field.toString().toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setFilteredRows(filtered);
  };
  async function init() {
    const result = await solisPowerApi.fetchBomCategories();
    console.log("result ==>", result);
    if (result) {
      setBody(result);
      const mappedRows = result.map((item, index) => ({
        id: item.id || index, // DataGrid ke liye mandatory
        name: item.name || "-",
        createddate: item.createddate || "-",
        bom_type: item.bom_type || "-",
        status: item.status || "-",
      }));

      setRows(mappedRows);
      setFilteredRows(mappedRows);
    } else {
      setBody([]);
    }
  }
  useEffect(() => {
    init();
  }, []);

  const columns = [
    {
      field: "name",
      headerName: "BOM Name",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Link
            to={`${ROUTES.BOM.VIEW.replace(":id", row.id)}`}
            state={row}
            style={{
              color: "#1a73e8",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            {row.name}
          </Link>
        );
      },
    },
    {
      field: "bom_type",
      headerName: "Type",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const bomType = params.row.bom_type || "STANDARD";

        return (
          <Badge bg={bomType === "MOUNTING_STRUCTURE" ? "info" : "secondary"}>
            {bomType === "MOUNTING_STRUCTURE"
              ? "Mounting Structure"
              : "Standard"}
          </Badge>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const status = params.row.status;
        return (
          <Badge bg={status === "Active" ? "success" : "secondary"}>
            {status}
          </Badge>
        );
      },
    },
    {
      field: "createddate",
      headerName: "Created Date",
      flex: 1,
      sortable: true,
      renderCell: (params) =>
        params.row?.createddate
          ? formatDateForView(params.row.createddate)
          : "",
    },
  ];

  // ========================================= 11-02-2026 ==========================================

  const createBom = () => {
    navigate(`/boms/e`);
  };

  return (
    <Main>
      <Container>
        <Row className="">
          <Col lg={12} className="">
            <Row className="align-items-end my-2">
              {/* Added By Jaseem 11-02-2026 */}
              <Col lg={2} md={4} xl={2} sm={12} className="">
                <div className="leads-header">
                  <div className="leads-actions">
                    <TextField
                      size="small"
                      placeholder="Search BOM..."
                      className="custom-search-field"
                      value={searchText}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </div>
                </div>
              </Col>
              {/* =================================================== */}
              <Col lg={2} md={4} sm={12} className="py-1">
                <div className="d-flex py-1 px-2 ">
                  <InfoPill
                    left="Total"
                    right={body?.length}
                    rightClasses="bg-custom text-white border-white fw-bold"
                    leftClasses="bg-white  fw-bold "
                  />
                </div>
              </Col>

              <Col className="d-flex flex-col justify-content-end align-items-end">
                {[PERMISSIONS.MODIFY_ALL].some((permission) => {
                  return userInfo?.permissions
                    .map((p) => p.name)
                    .includes(permission);
                }) && (
                    <Button
                      size="sm"
                      className="btn-create"
                      onClick={() => createBom(true)}
                    >
                      New BOM
                    </Button>
                  )}
              </Col>
            </Row>
            {/* Added By Jaseem 11-02-2026 */}
            <Row>
              <div className="leads-page">
                {/* Header */}

                {/* DataGrid */}
                <div
                  style={{
                    height: 400,
                    width: "100%",
                    marginTop: "20px",
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                  }}
                >
                  <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    pageSize={25}
                    rowsPerPageOptions={[25]}
                    getRowHeight={() => "auto"}
                    disableRowSelectionOnClick
                    className="custom-datagrid"
                  />
                </div>
              </div>
            </Row>
            {/* ==========================End By Jaseem ============================================= */}
          </Col>
        </Row>
      </Container>
    </Main>
  );
};
export default BomList;
